// build: 2026-04-22-asset-fix
import { createRouter as createTanStackRouter } from "@tanstack/react-router"
import { createIsomorphicFn } from "@tanstack/react-start"
import { DefaultCatchBoundary } from "./components/DefaultCatchBoundary"
import { NotFound } from "./components/not-found"
import { getClientRootContext } from "./contexts/root-context/getClientRootContext"
import { getServerRootContext } from "./contexts/root-context/getServerRootContext"
import { routeTree } from "./routeTree.gen"

const getRootContext = createIsomorphicFn()
  .client(getClientRootContext)
  .server(getServerRootContext)

export function getRouter() {
  const router = createTanStackRouter({
    routeTree,
    context: getRootContext(),
    defaultPreload: "intent",
    defaultErrorComponent: DefaultCatchBoundary,
    defaultNotFoundComponent: () => <NotFound />,
    scrollRestoration: true,
  })

  return router
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>
  }
}
